import { SimpleShowLayoutProps as RaSimpleShowLayoutProps } from 'react-admin';

import { StyledSimpleShowLayout } from './SimpleShowLayout.styled';

export const SimpleShowLayout = StyledSimpleShowLayout;

export type SimpleShowLayoutProps = RaSimpleShowLayoutProps;
